export enum OperationFeedbackItemDownloadStatus {
  Progress = 'Progress',
  Failed = 'Failed',
  Completed = 'Completed',
}
